import { dynamicLengthValidator } from "../../../../common/Utils/Utils";
import {
  confirmPasswordValidator,
  emailValidator,
  passwordValidator,
} from "../../../../common/Validators/Validators";

// forgot Password - Email
export const forgotPasswordEmailField = () => [
  {
    label: "Email",
    field: "email",
    span: 24,
    type: "text",
    maxLength: 254,
    placeholder: "Enter your email",
    required: true,
    rules: [
      { required: true, message: "Email is required" },
      {
        validator: dynamicLengthValidator(6, "Email"),
      },
      emailValidator("Please enter a valid email"),
    ],
  },
];

//fogotPassword New password - confimPassword
export const forgotPasswordField = (form) => [
  {
    field: "password",
    label: "Password",
    span: 24,
    maxLength: 15,
    type: "password",
    required: true,
    placeholder: "Enter your password",
    rules: [{ validator: passwordValidator }],
  },
  {
    field: "confirmPassword",
    label: "Confirm Password",
    span: 24,
    maxLength: 15,
    type: "password",
    required: true,
    placeholder: "Re-enter your password",
    rules: [
      {
        validator: (value, callback) => {
          confirmPasswordValidator(
            value,
            callback,
            form.getFieldValue("password")
          );
        },
      },
    ],
  },
];
